var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsset4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1160.9 175.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{isolation:isolate;}.cls-4{fill:#0095c7;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 93.31,
    y1: 59.19,
    x2: 185.96,
    y2: 59.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006f95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a8e1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 69.76,
    x2: 121.09,
    y2: 69.76,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.1,118.2c-1.1-3.8-2.4-7.6-4-11.6a182.1,182.1,0,0,0-10.4-22.4A167.5,167.5,0,0,0,93.3,63.4h0a183.2,183.2,0,0,1,20.9-23.1l7.1-6.2A169.8,169.8,0,0,1,186,.2L173,23.7l-43.1,78.4-.4.9-2,3.6-6.4,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.1,118.2l-4.5,8.2a22.3,22.3,0,0,1-2,3l-.5.7c-.6.8-1.2,1.4-1.8,2.1l-1.2,1.1-1.5,1.1a12.7,12.7,0,0,1-2.7,1.8,32.2,32.2,0,0,1-4.6,2.1h-.2a25.8,25.8,0,0,1-24.3-4.8,29.8,29.8,0,0,1-3.8-4.1l-1.2-1.8-.6-1-6-10.5-5.4-9.5-3.4-6L13.5,23.7,0,0A172.8,172.8,0,0,1,65.4,34c2.5,2,4.8,4.1,7.1,6.3A163.3,163.3,0,0,1,93.3,63.4h0a167.5,167.5,0,0,1,13.4,20.8,182.1,182.1,0,0,1,10.4,22.4C118.7,110.6,120,114.4,121.1,118.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.5,17.2l20.2,59.7c.7,1.9,1.4,4.1,2.3,6.8s1.7,5.3,2.6,8,1.7,5.5,2.6,8.2,1.5,5.2,2.1,7.5h.5l2.1-7.2,2.4-8.1c.8-2.6,1.7-5.3,2.5-7.8s1.6-4.9,2.3-7.1l20.9-60h22.5L303.1,129.7h-23L238.5,17.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M365,25.5a11.4,11.4,0,0,1-8.6-3.3,10.9,10.9,0,0,1-3.1-8,10.6,10.6,0,0,1,3.2-7.9A11.3,11.3,0,0,1,365,3c3.5,0,6.3,1,8.4,3.2a10.6,10.6,0,0,1,3.3,8,10.6,10.6,0,0,1-3.3,8A11.1,11.1,0,0,1,365,25.5ZM354.5,129.7V44.9h21.1v84.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M455.2,2.6h21.1V129.7H460.6l-2.3-9.3h-.8a31.6,31.6,0,0,1-10,8c-3.9,2.1-9,3.1-15.1,3.1a36.5,36.5,0,0,1-14.3-2.8,34.3,34.3,0,0,1-11.9-8.5,40.3,40.3,0,0,1-8-13.9,54.3,54.3,0,0,1-3-18.9,59.9,59.9,0,0,1,2.6-18.1,38.9,38.9,0,0,1,7.6-13.9,33.2,33.2,0,0,1,12.2-9A42.4,42.4,0,0,1,434,43.3a35.6,35.6,0,0,1,11.8,1.9,25.8,25.8,0,0,1,9.4,5.2Zm0,64.1a22.9,22.9,0,0,0-7.1-5.7,20,20,0,0,0-9.1-2.2,22.2,22.2,0,0,0-8.5,1.6,18.2,18.2,0,0,0-7.2,4.9,25.9,25.9,0,0,0-5,8.7,41,41,0,0,0-1.8,12.9,42.3,42.3,0,0,0,1.7,13,25.3,25.3,0,0,0,4.5,9,18.5,18.5,0,0,0,6.7,5.2,20.6,20.6,0,0,0,8.1,1.7,18.8,18.8,0,0,0,10.4-2.8,21.8,21.8,0,0,0,7.3-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M489.1,44.9H512l15.9,43.2,5.9,20.4h.5L540,87.9l14.3-43h21.6l-31.6,89.3a82.1,82.1,0,0,1-13.9,25.5c-5.8,7.2-13.8,12.5-23.9,15.9l-9-16.6a47.6,47.6,0,0,0,16.2-10,37,37,0,0,0,9.7-16.4l.9-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M587.7,52.4a84.1,84.1,0,0,1,15.9-6.7,61.1,61.1,0,0,1,17.7-2.4A50.9,50.9,0,0,1,634.8,45a27.3,27.3,0,0,1,10.6,5.4,25,25,0,0,1,6.8,9.8,36.9,36.9,0,0,1,2.5,14.5v55H638.1l-2.2-8.9h-.5c-6.1,7.1-14.7,10.7-25.9,10.7-8.9,0-15.9-2.3-20.9-7s-7.5-10.8-7.5-18.3a24.5,24.5,0,0,1,3-12.4,25.9,25.9,0,0,1,8.3-8.5A37.8,37.8,0,0,1,605,80.2a66.9,66.9,0,0,1,15.9-1.7h12.5V72.6c0-4.7-1.4-8-4.1-9.9s-6.4-3-11.1-3a42,42,0,0,0-10.6,1.6,59.3,59.3,0,0,0-12.4,5.6Zm45.9,39.5-9.7.3c-7.8.3-13.3,1.6-16.4,4s-4.6,5.4-4.6,8.9,1.3,7.4,3.9,8.9a17.1,17.1,0,0,0,9.1,2.3,19.3,19.3,0,0,0,9.9-2.6,20.7,20.7,0,0,0,7.8-7.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M718.2,17.2h38.1a57,57,0,0,1,17.1,2.4,37.4,37.4,0,0,1,13.2,6.7A28.7,28.7,0,0,1,795.1,37,33.2,33.2,0,0,1,798,51.5a36,36,0,0,1-3.4,16.3,31.7,31.7,0,0,1-9.2,11.3,39.6,39.6,0,0,1-14,6.7,67.8,67.8,0,0,1-17.3,2.1H740v41.8H718.2ZM740,71h10a52.4,52.4,0,0,0,10-.9,24.3,24.3,0,0,0,8.1-3,15.3,15.3,0,0,0,5.5-5.8,18.1,18.1,0,0,0,1.9-8.9,19.2,19.2,0,0,0-1.7-8.3,16.1,16.1,0,0,0-5-5.7,19.9,19.9,0,0,0-7.2-3.3A34.3,34.3,0,0,0,753,34H740Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M891.6,86.7a51.3,51.3,0,0,1-3.3,18.9,39.7,39.7,0,0,1-9.2,14.1,40.3,40.3,0,0,1-13.7,8.8,47.5,47.5,0,0,1-17,3,48.7,48.7,0,0,1-16.9-2.8,38.8,38.8,0,0,1-13.5-8.3,38.3,38.3,0,0,1-8.9-13.5,50.3,50.3,0,0,1-3.2-18.4,52.2,52.2,0,0,1,3.3-19.2,39.2,39.2,0,0,1,9.2-14.2,41.8,41.8,0,0,1,13.7-8.8,47.5,47.5,0,0,1,17-3A48.7,48.7,0,0,1,866,46.1a36.8,36.8,0,0,1,13.5,8.3,39.7,39.7,0,0,1,8.9,13.5A51.8,51.8,0,0,1,891.6,86.7Zm-21.8.9A41.9,41.9,0,0,0,868,74.5a25,25,0,0,0-4.7-8.9,19.4,19.4,0,0,0-6.8-5,21.4,21.4,0,0,0-7.9-1.6,23,23,0,0,0-7.9,1.4,15.6,15.6,0,0,0-6.6,4.6,24.4,24.4,0,0,0-4.6,8.8,45.3,45.3,0,0,0-1.8,13.8,40.3,40.3,0,0,0,1.8,12.8,24.1,24.1,0,0,0,4.7,8.7,18.5,18.5,0,0,0,6.8,5.1,19.6,19.6,0,0,0,7.9,1.6,23.8,23.8,0,0,0,7.8-1.4,17.1,17.1,0,0,0,6.7-4.7,24,24,0,0,0,4.6-8.6A44.1,44.1,0,0,0,869.8,87.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M909.1,129.7V44.9h16.2L928,60.8a29.9,29.9,0,0,1,9.7-12.4c4.4-3.4,9.8-5.1,16.4-5.1a28.6,28.6,0,0,1,7.5.9,24.6,24.6,0,0,1,5.3,2l-3.5,17.1a28.2,28.2,0,0,0-4.8-1.9,28.7,28.7,0,0,0-7-.8,20.9,20.9,0,0,0-15.4,6.3C932.1,71,930,77.7,930,86.7v43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1030,60.3h-23.4v42.5c0,4,1,6.8,2.9,8.3a12.2,12.2,0,0,0,7.6,2.2,39.5,39.5,0,0,0,7.5-.7,25.8,25.8,0,0,0,6.6-2l3.2,15a51.5,51.5,0,0,1-9.2,2.8,54.2,54.2,0,0,1-12.4,1.3c-9.6,0-16.5-1.9-20.8-5.9s-6.3-9.8-6.3-17.6V60.3H972.8V44.9h12.9V18.5h20.9V44.9H1030Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1049.8,52.4a84.1,84.1,0,0,1,15.9-6.7,61.1,61.1,0,0,1,17.7-2.4,50.9,50.9,0,0,1,13.5,1.7,27.3,27.3,0,0,1,10.6,5.4,25,25,0,0,1,6.8,9.8,38.8,38.8,0,0,1,2.5,14.5v55h-16.7l-2.1-8.9h-.5c-6.1,7.1-14.7,10.7-25.9,10.7-9,0-15.9-2.3-20.9-7s-7.5-10.8-7.5-18.3a24.5,24.5,0,0,1,3-12.4,25,25,0,0,1,8.3-8.5,37.8,37.8,0,0,1,12.6-5.1,66.9,66.9,0,0,1,15.9-1.7h12.5V72.6c0-4.7-1.4-8-4.1-9.9s-6.4-3-11.1-3a42,42,0,0,0-10.6,1.6,59.3,59.3,0,0,0-12.4,5.6Zm45.9,39.5-9.7.3c-7.8.3-13.3,1.6-16.4,4s-4.6,5.4-4.6,8.9,1.3,7.4,3.9,8.9a17.1,17.1,0,0,0,9.1,2.3,19.3,19.3,0,0,0,9.9-2.6,20.7,20.7,0,0,0,7.8-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1140.1,129.7V2.6h20.8V129.7Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/Asset 4.9df6f2abf07a54c58607bf9d8bafe063.svg";
export { ForwardRef as ReactComponent };